export const data=[
    {name: 'Jan', arrival: 4000, spending: 2400},
    {name: 'Feb', arrival: 3000, spending: 1398},
    {name: 'Mar', arrival: 2000, spending: 9800},
    {name: 'Apr', arrival: 2780, spending: 3908},
    {name: 'Nay', arrival: 1890, spending: 4800},
    {name: 'Jun', arrival: 2390, spending: 3800},
    {name: 'Jul', arrival: 3490, spending: 4300}
  ];